'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  textarea {\n    resize: vertical;\n    appearance: none;\n    background-color: ', ';\n    border: 2px solid ', ';\n    border-radius: ', ';\n    color: inherit;\n    font-size: ', ';\n    height: ', ';\n    padding: ', ';\n    vertical-align: middle;\n    box-shadow: inset 0 2px 3px ', ';\n    width: 100%;\n    margin-bottom: ', ';\n\n    &:disabled {\n      background-color: ', ';\n    }\n\n    &:focus {\n      box-shadow: inset 0 2px 3px ', ';\n      border-color: ', ';\n      outline: 0;\n    }\n\n    ', ' ', ';\n  }\n'], ['\n  textarea {\n    resize: vertical;\n    appearance: none;\n    background-color: ', ';\n    border: 2px solid ', ';\n    border-radius: ', ';\n    color: inherit;\n    font-size: ', ';\n    height: ', ';\n    padding: ', ';\n    vertical-align: middle;\n    box-shadow: inset 0 2px 3px ', ';\n    width: 100%;\n    margin-bottom: ', ';\n\n    &:disabled {\n      background-color: ', ';\n    }\n\n    &:focus {\n      box-shadow: inset 0 2px 3px ', ';\n      border-color: ', ';\n      outline: 0;\n    }\n\n    ', ' ', ';\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TextAreaStyled = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.bahFormInputBackgroundColor;
}, function (props) {
  return props.theme.bahFormInputBorderColor;
}, function (props) {
  return props.theme.bahFormFieldsDefaultBorder;
}, function (props) {
  return props.textSize;
}, function (props) {
  return props.theme.bahFormInputDefaultHeight;
}, function (props) {
  return props.theme.bahFormInputDefaultPadding;
}, function (props) {
  return props.theme.bahFormInputBoxShadowColor;
}, function (props) {
  return props.theme.bahFormFieldsDefaultMarginBottom;
}, function (props) {
  return props.theme.bahFormInputDisabledColor;
}, function (props) {
  return props.theme.bahFormInputFocusShadowColor;
}, function (props) {
  return props.theme.bahFormInputFocusBorderColor;
}, function (props) {
  return props.isValid && '\n      box-shadow:inset 0 2px 3px ' + props.theme.bahColors.green100 + ';\n      border-color: ' + props.theme.bahColors.green300 + ';\n      outline: 0;\n      &:focus {\n        box-shadow:inset 0 2px 3px ' + props.theme.bahColors.green200 + ';\n        border-color: ' + props.theme.bahColors.green400 + ';\n        outline: 0;\n      }\n    ';
}, function (props) {
  return props.isInvalid && '\n      box-shadow:inset 0 2px 3px ' + props.theme.bahColors.red100 + ';\n      border-color: ' + props.theme.bahColors.red300 + ';\n      outline: 0;\n      &:focus {\n        box-shadow:inset 0 2px 3px ' + props.theme.bahColors.red200 + ';\n        border-color: ' + props.theme.bahColors.red400 + ';\n        outline: 0;\n      }\n    ';
});

exports.default = TextAreaStyled;


//////////////////
// WEBPACK FOOTER
// ./~/@rafacdb/bah/lib/TextAreaStyled.js
// module id = 112
// module chunks = 0